// extracted by mini-css-extract-plugin
module.exports = {"action":"TagListMultiTerms_action__3tAAj","containerModale":"TagListMultiTerms_containerModale__ZGyIW","titleModale":"TagListMultiTerms_titleModale__1cd4m"};